// extracted by mini-css-extract-plugin
export var infoItem = "_ow-2";
export var title = "_ow-0";
export var value = "_ow-1";